var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"crly-a-common-search-category-large-label crly-icon",class:_vm.category.catExlCd,on:{"click":_vm.clickLrgCat}},[_c('span',[_vm._v(" "+_vm._s(_vm.category.catLrgNm)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }